import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { AsyncSupportWebsiteNav } from '@jira/navigation-apps__horizontal-nav-csm-support-website/src/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { HelpCenterSettingsSupportWebsiteEditAppEntryPoint as main } from '@jira/spa-apps__help-center-settings-support-website-edit/src/HelpCenterSettingsSupportWebsiteEditAppEntryPoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { csmAppSidebarEntryPoint } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-csm-app/src/csmAppSidebarEntryPoint.entrypoint.tsx';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';
import { csmHubSetupSupportWebsiteResource } from '@jira/router-resources__customer-service-common/src/csmHubSetupSupportWebsiteResource.tsx';
import { csmExperienceSupportWebsiteEditRoute } from '@jira/router-routes__help-center-settings-routes/src/csmExperienceSupportWebsiteEditRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';

import { getCsmExperiencesResources } from './getCsmExperiencesResources.tsx';

const csmExperienceSupportWebsiteEditPageEntryPoint = createPageEntryPoint({
	main,
	leftSidebar: {
		sidebar: csmAppSidebarEntryPoint,
	},
});

export const csmExperienceSupportWebsiteEditRouteEntry: Route = createEntry(
	csmExperienceSupportWebsiteEditRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'customer-service.csm-experience-support-website.edit',
		layout: serviceProjectLayout,
		navigation: {
			sidebarId: SidebarIdCsmApp,
			horizontal: fg('csm_contact_us_rte') ? undefined : AsyncSupportWebsiteNav,
		},
		entryPoint() {
			return fg('csm_appification_standalone_navigation')
				? csmExperienceSupportWebsiteEditPageEntryPoint
				: notFoundPageEntrypoint;
		},
		resources: [
			...getCustomerServiceL1NavigationResources(),
			...getCsmExperiencesResources(),
			staticProjectSidebarNavigationResource,
			csmHubSetupSupportWebsiteResource,
		],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
